import Layout from "../../layout/Layout";
import { cn } from "../../../utils/classnames";

// Page shell shared by every admin list screen: the booking list's title block
// (22px semibold heading + hairline divider) inside the standard admin column.
export const AdminPageHeader = ({ title, actions }) => (
  <div className="tw:pt-[34px]">
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-3">
      <div className="tw:mb-0 tw:font-hanken-grotesk tw:text-[22px] tw:font-semibold tw:leading-[normal] tw:text-[#212529]">
        {title}
      </div>
      {actions ? <div className="tw:flex tw:items-center tw:gap-2">{actions}</div> : null}
    </div>
    <div className="tw:mt-[34px] tw:h-px tw:w-full tw:bg-[#E6E6E6]" />
  </div>
);

const AdminPage = ({ title, actions, className, children }) => (
  <Layout>
    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 tw:pb-[42px] w-100">
      <div className={cn("tw:font-hanken-grotesk tw:text-[#212529]", className)}>
        <AdminPageHeader title={title} actions={actions} />
        {children}
      </div>
    </main>
  </Layout>
);

export default AdminPage;
